import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination, Navigation } from 'swiper/modules';
import 'swiper/css';
import { Fade, Slide } from "react-awesome-reveal";
import { isMobileDevice } from '../../utils';
import { useState } from 'react';


export default function Home() {
  const [swiperRef, setSwiperRef]: any = useState(null);
  const [swiperIndex, setSwiperIndex] = useState(0);
  return (
    <div className=' '>
      <div className='w-[960px] mx-auto relative mt-[30px] h5:w-full'>
        <Swiper
          slidesPerView={isMobileDevice() ? 1 : 3}
          autoplay={{
            delay: 100000,
            // disableOnInteraction: false,
          }}
          loop={false}
          modules={[Autoplay, Pagination]}
          pagination={{
            clickable: true,  // 使指示点可点击
            bulletClass: 'swiper-pagination-bullet2',  // 指示点的类名
            bulletActiveClass: 'swiper-pagination-bullet-active2',  // 活动指示点的类名
          }}
          ref={swiperRef}
          onSwiper={setSwiperRef}
          onSlideChange={(swiper: any) => {
            setSwiperIndex(swiper.activeIndex);
          }}
        >
          <SwiperSlide>
            <Fade cascade={true} direction="down" delay={0} duration={600} triggerOnce={true}>
              <div className="px-[15px] h5:px-[80px] h5:pb-20">
                <img src={require('../../assets/image/icon11.png')} alt=""
                  className='w-full' />
              </div>
            </Fade>
          </SwiperSlide>
          <SwiperSlide>
            <Fade cascade={true} direction="down" delay={100} duration={700} triggerOnce={true}>
              <div className="px-[15px] h5:px-[80px] h5:pb-20">
                <img src={require('../../assets/image/icon12.png')} alt=""
                  className='w-full' />
              </div>
            </Fade>
          </SwiperSlide>
          <SwiperSlide>
            <Fade cascade={true} direction="down" delay={200} duration={800} triggerOnce={true}>
              <div className="px-[15px] h5:px-[80px] h5:pb-20">
                <img src={require('../../assets/image/icon13.png')} alt=""
                  className='w-full' />
              </div>
            </Fade>
          </SwiperSlide>
        </Swiper>
        <div className={`${isMobileDevice() ? 'block' : 'hidden'}`}>
          <div className={`${swiperIndex === 0 ? 'opacity-20' : 'opacity-60'} absolute top-[46%] left-[20px] z-[10]`}
            onClick={() => {
              swiperRef.slideTo(swiperIndex === 0 ? 0 : swiperIndex - 1);
            }}>
            <img src={require('../../assets/image/icon1.png')} alt=""
              className='w-[20px] rotate-[180deg]'
            />
          </div>
          <div className={`${swiperIndex === 2 ? 'opacity-20' : 'opacity-60'} absolute top-[46%] right-[20px] z-[10]`}
            onClick={() => {
              swiperRef.slideTo(swiperIndex === 2 ? 2 : swiperIndex + 1);
            }}>
            <img src={require('../../assets/image/icon1.png')} alt=""
              className='w-[20px] rotate-[0deg]'
            />
          </div>
        </div>

      </div>
    </div>
  );
}
